import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full font-sans bg-gray-50 flex flex-col" data-id="element-1534">
      <SEOHead title="Privacy Policy | Smith & Jengs Cleaning Services" description="Read the Smith & Jengs Cleaning Services privacy policy. Learn how we collect, use, and protect your personal data in compliance with UK data protection laws." canonical="https://smithandjengs.com/privacy-policy" data-id="element-1535" />
      <BreadcrumbSchema items={[{
      name: 'Home',
      url: 'https://smithandjengs.com/'
    }, {
      name: 'Privacy Policy',
      url: 'https://smithandjengs.com/privacy-policy'
    }]} data-id="element-1536" />
      <Navbar data-id="element-1537" />

      <main className="flex-1 pt-32 pb-24 px-6 md:px-12" data-id="element-1538">
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-16 rounded-xl shadow-sm border border-gray-100" data-id="element-1539">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1540">
            <h1 className="text-5xl md:text-7xl font-bebas text-[#1a2744] mb-8 tracking-wide" data-id="element-1541">
              PRIVACY POLICY
            </h1>

            <div className="prose prose-lg max-w-none text-gray-600 font-poppins space-y-8" data-id="element-1542">
              <p className="text-lg leading-relaxed" data-id="element-1543">
                Last updated:{' '}
                {new Date().toLocaleDateString('en-GB', {
                month: 'long',
                year: 'numeric'
              })}
              </p>

              <section data-id="element-1544">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1545">
                  1. Introduction
                </h2>
                <p className="leading-relaxed" data-id="element-1546">
                  Welcome to Smith & Jengs Cleaning Services ("we," "our," or
                  "us"). We are committed to protecting your personal data and
                  respecting your privacy. This Privacy Policy explains how we
                  collect, use, disclose, and safeguard your information when
                  you visit our website or use our services.
                </p>
              </section>

              <section data-id="element-1547">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1548">
                  2. Information We Collect
                </h2>
                <p className="leading-relaxed mb-4" data-id="element-1549">
                  We may collect and process the following data about you:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-1550">
                  <li data-id="element-1551">
                    <strong data-id="element-1552">Identity Data:</strong> First name, last name,
                    title.
                  </li>
                  <li data-id="element-1553">
                    <strong data-id="element-1554">Contact Data:</strong> Billing address, service
                    address, email address, and telephone numbers.
                  </li>
                  <li data-id="element-1555">
                    <strong data-id="element-1556">Financial Data:</strong> Payment card details
                    (processed securely by our payment providers).
                  </li>
                  <li data-id="element-1557">
                    <strong data-id="element-1558">Transaction Data:</strong> Details about payments to
                    and from you and other details of services you have
                    purchased from us.
                  </li>
                  <li data-id="element-1559">
                    <strong data-id="element-1560">Technical Data:</strong> Internet protocol (IP)
                    address, browser type and version, time zone setting and
                    location.
                  </li>
                </ul>
              </section>

              <section data-id="element-1561">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1562">
                  3. How We Use Your Information
                </h2>
                <p className="leading-relaxed mb-4" data-id="element-1563">
                  We use the information we collect in various ways, including
                  to:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-1564">
                  <li data-id="element-1565">Provide, operate, and maintain our services.</li>
                  <li data-id="element-1566">Process and manage your bookings and payments.</li>
                  <li data-id="element-1567">
                    Communicate with you regarding your appointments, inquiries,
                    and customer support.
                  </li>
                  <li data-id="element-1568">
                    Improve, personalize, and expand our website and services.
                  </li>
                  <li data-id="element-1569">
                    Send you marketing communications (if you have opted in).
                  </li>
                </ul>
              </section>

              <section data-id="element-1570">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1571">
                  4. Cookies and Tracking Technologies
                </h2>
                <p className="leading-relaxed" data-id="element-1572">
                  We use cookies and similar tracking technologies to track the
                  activity on our website and hold certain information. Cookies
                  are files with a small amount of data which may include an
                  anonymous unique identifier. You can instruct your browser to
                  refuse all cookies or to indicate when a cookie is being sent.
                  However, if you do not accept cookies, you may not be able to
                  use some portions of our website.
                </p>
              </section>

              <section data-id="element-1573">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1574">
                  5. Data Security
                </h2>
                <p className="leading-relaxed" data-id="element-1575">
                  We have put in place appropriate security measures to prevent
                  your personal data from being accidentally lost, used, or
                  accessed in an unauthorized way, altered, or disclosed. In
                  addition, we limit access to your personal data to those
                  employees, agents, contractors, and other third parties who
                  have a business need to know.
                </p>
              </section>

              <section data-id="element-1576">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1577">
                  6. Your Legal Rights
                </h2>
                <p className="leading-relaxed mb-4" data-id="element-1578">
                  Under certain circumstances, you have rights under data
                  protection laws in relation to your personal data, including
                  the right to:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-1579">
                  <li data-id="element-1580">Request access to your personal data.</li>
                  <li data-id="element-1581">Request correction of your personal data.</li>
                  <li data-id="element-1582">Request erasure of your personal data.</li>
                  <li data-id="element-1583">Object to processing of your personal data.</li>
                  <li data-id="element-1584">Request restriction of processing your personal data.</li>
                  <li data-id="element-1585">Request transfer of your personal data.</li>
                  <li data-id="element-1586">Right to withdraw consent.</li>
                </ul>
              </section>

              <section data-id="element-1587">
                <h2 className="text-3xl font-bebas text-[#1a2744] mb-4 tracking-wide" data-id="element-1588">
                  7. Contact Us
                </h2>
                <p className="leading-relaxed" data-id="element-1589">
                  If you have any questions about this Privacy Policy or our
                  privacy practices, please contact us at:
                </p>
                <div className="mt-4 bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-1590">
                  <p className="font-semibold text-[#1a2744]" data-id="element-1591">
                    Smith & Jengs Cleaning Services
                  </p>
                  <p className="mt-2" data-id="element-1592">
                    Email:{' '}
                    <a href="mailto:smithsandjengs@yahoo.com" className="text-[#e91e8c] hover:underline" data-id="element-1593">
                      smithsandjengs@yahoo.com
                    </a>
                  </p>
                  <p className="mt-1" data-id="element-1594">
                    Phone:{' '}
                    <a href="tel:07432285564" className="text-[#e91e8c] hover:underline" data-id="element-1595">
                      07432285564
                    </a>
                  </p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-1596" />
    </div>;
}